/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * NoorWriter API
 * API for NoorWriter Chrome extension - AI writing assistant
 *
 * The version of the OpenAPI document: v1
 * Contact: contact@noorways.fr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios from 'axios'
import type { AxiosPromise, AxiosInstance } from 'axios'
import type { Configuration } from '../configuration'
import type { RequestConfig } from '../base'
// Some imports not used depending on template conditions
// @ts-ignore
import * as Common from '../common'
const {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} = Common
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from '../base'
import type { RequestArgs } from '../base'
// @ts-ignore
import type { AuthResponse } from '../models'
// @ts-ignore
import type { ChangePasswordRequest } from '../models'
// @ts-ignore
import type { ExchangeTokenRequest } from '../models'
// @ts-ignore
import type { ForgotPasswordRequest } from '../models'
// @ts-ignore
import type { LoginRequest } from '../models'
// @ts-ignore
import type { ProblemDetails } from '../models'
// @ts-ignore
import type { RedirectTokenResponse } from '../models'
// @ts-ignore
import type { RegisterRequest } from '../models'
// @ts-ignore
import type { ResetPasswordRequest } from '../models'
// @ts-ignore
import type { UpdateProfileRequest } from '../models'
// @ts-ignore
import type { UserInfo } from '../models'
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Change password
     * @param {ChangePasswordRequest} [changePasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword: async (
      changePasswordRequest?: ChangePasswordRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/change-password`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        changePasswordRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Exchange a one-time redirect token for a full authentication token
     * @param {ExchangeTokenRequest} [exchangeTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeRedirectToken: async (
      exchangeTokenRequest?: ExchangeTokenRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/exchange-redirect-token`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        exchangeTokenRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Initiate password reset
     * @param {ForgotPasswordRequest} [forgotPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword: async (
      forgotPasswordRequest?: ForgotPasswordRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/forgot-password`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        forgotPasswordRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Generate a one-time token for secure web redirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRedirectToken: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/generate-redirect-token`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get current user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUser: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Authenticate user with email and password
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login: async (
      loginRequest?: LoginRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/login`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        loginRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Logout current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/logout`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Refresh JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/refresh`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Register a new user account
     * @param {RegisterRequest} [registerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register: async (
      registerRequest?: RegisterRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/register`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete password reset
     * @param {ResetPasswordRequest} [resetPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword: async (
      resetPasswordRequest?: ResetPasswordRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/reset-password`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        resetPasswordRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update user profile
     * @param {UpdateProfileRequest} [updateProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProfile: async (
      updateProfileRequest?: UpdateProfileRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/profile`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateProfileRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Verify email address
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyEmail: async (token?: string, options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/verify-email`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (token !== undefined) {
        localVarQueryParameter['token'] = token
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Verify password reset token validity
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyResetToken: async (token?: string, options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/verify-reset-token`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (token !== undefined) {
        localVarQueryParameter['token'] = token
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Change password
     * @param {ChangePasswordRequest} [changePasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changePassword(
      changePasswordRequest?: ChangePasswordRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(
        changePasswordRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Exchange a one-time redirect token for a full authentication token
     * @param {ExchangeTokenRequest} [exchangeTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exchangeRedirectToken(
      exchangeTokenRequest?: ExchangeTokenRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeRedirectToken(
        exchangeTokenRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Initiate password reset
     * @param {ForgotPasswordRequest} [forgotPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotPassword(
      forgotPasswordRequest?: ForgotPasswordRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(
        forgotPasswordRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Generate a one-time token for secure web redirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateRedirectToken(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectTokenResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generateRedirectToken(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Get current user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCurrentUser(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfo>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Authenticate user with email and password
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login(
      loginRequest?: LoginRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Logout current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logout(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Refresh JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refreshToken(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Register a new user account
     * @param {RegisterRequest} [registerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async register(
      registerRequest?: RegisterRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerRequest, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Complete password reset
     * @param {ResetPasswordRequest} [resetPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetPassword(
      resetPasswordRequest?: ResetPasswordRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(
        resetPasswordRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Update user profile
     * @param {UpdateProfileRequest} [updateProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProfile(
      updateProfileRequest?: UpdateProfileRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfo>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(
        updateProfileRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Verify email address
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyEmail(
      token?: string,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(token, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Verify password reset token validity
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyResetToken(
      token?: string,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyResetToken(token, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
  }
}

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthApiFp(configuration)
  return {
    /**
     *
     * @summary Change password
     * @param {ChangePasswordRequest} [changePasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword(
      changePasswordRequest?: ChangePasswordRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .changePassword(changePasswordRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Exchange a one-time redirect token for a full authentication token
     * @param {ExchangeTokenRequest} [exchangeTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exchangeRedirectToken(
      exchangeTokenRequest?: ExchangeTokenRequest,
      options?: any
    ): AxiosPromise<AuthResponse> {
      return localVarFp
        .exchangeRedirectToken(exchangeTokenRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Initiate password reset
     * @param {ForgotPasswordRequest} [forgotPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      forgotPasswordRequest?: ForgotPasswordRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .forgotPassword(forgotPasswordRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Generate a one-time token for secure web redirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRedirectToken(options?: any): AxiosPromise<RedirectTokenResponse> {
      return localVarFp.generateRedirectToken(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get current user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUser(options?: any): AxiosPromise<UserInfo> {
      return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Authenticate user with email and password
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(loginRequest?: LoginRequest, options?: any): AxiosPromise<AuthResponse> {
      return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Logout current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(options?: any): AxiosPromise<void> {
      return localVarFp.logout(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Refresh JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(options?: any): AxiosPromise<AuthResponse> {
      return localVarFp.refreshToken(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Register a new user account
     * @param {RegisterRequest} [registerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(registerRequest?: RegisterRequest, options?: any): AxiosPromise<AuthResponse> {
      return localVarFp
        .register(registerRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Complete password reset
     * @param {ResetPasswordRequest} [resetPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(resetPasswordRequest?: ResetPasswordRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .resetPassword(resetPasswordRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update user profile
     * @param {UpdateProfileRequest} [updateProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProfile(
      updateProfileRequest?: UpdateProfileRequest,
      options?: any
    ): AxiosPromise<UserInfo> {
      return localVarFp
        .updateProfile(updateProfileRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Verify email address
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyEmail(token?: string, options?: any): AxiosPromise<void> {
      return localVarFp.verifyEmail(token, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Verify password reset token validity
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyResetToken(token?: string, options?: any): AxiosPromise<void> {
      return localVarFp.verifyResetToken(token, options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
  /**
   *
   * @summary Change password
   * @param {ChangePasswordRequest} [changePasswordRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public changePassword(changePasswordRequest?: ChangePasswordRequest, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .changePassword(changePasswordRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Exchange a one-time redirect token for a full authentication token
   * @param {ExchangeTokenRequest} [exchangeTokenRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public exchangeRedirectToken(
    exchangeTokenRequest?: ExchangeTokenRequest,
    options?: RequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .exchangeRedirectToken(exchangeTokenRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Initiate password reset
   * @param {ForgotPasswordRequest} [forgotPasswordRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public forgotPassword(forgotPasswordRequest?: ForgotPasswordRequest, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .forgotPassword(forgotPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Generate a one-time token for secure web redirection
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public generateRedirectToken(options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .generateRedirectToken(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get current user information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public getCurrentUser(options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .getCurrentUser(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Authenticate user with email and password
   * @param {LoginRequest} [loginRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public login(loginRequest?: LoginRequest, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .login(loginRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Logout current user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public logout(options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .logout(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Refresh JWT token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public refreshToken(options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .refreshToken(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Register a new user account
   * @param {RegisterRequest} [registerRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public register(registerRequest?: RegisterRequest, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .register(registerRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Complete password reset
   * @param {ResetPasswordRequest} [resetPasswordRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public resetPassword(resetPasswordRequest?: ResetPasswordRequest, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .resetPassword(resetPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update user profile
   * @param {UpdateProfileRequest} [updateProfileRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public updateProfile(updateProfileRequest?: UpdateProfileRequest, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .updateProfile(updateProfileRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Verify email address
   * @param {string} [token]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public verifyEmail(token?: string, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .verifyEmail(token, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Verify password reset token validity
   * @param {string} [token]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public verifyResetToken(token?: string, options?: RequestConfig) {
    return AuthApiFp(this.configuration)
      .verifyResetToken(token, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
